import { ActionStatus } from "common/enums";
import {
    CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_FAILURE,
    CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_REQUEST,
    CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS,
    GET_DATA_SYNDICATION_SUBSCRIPTION_FAILURE,
    GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_FAILURE,
    GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_REQUEST,
    GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_SUCCESS,
    GET_DATA_SYNDICATION_SUBSCRIPTION_REQUEST,
    GET_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS,
    GET_SUBSCRIPTION_SOURCE_DATA_SETS_FAILURE,
    GET_SUBSCRIPTION_SOURCE_DATA_SETS_REQUEST,
    GET_SUBSCRIPTION_SOURCE_DATA_SETS_SUCCESS,
} from "./actions";

const initialState = {
    getDataSyndicationSubscriptionListAction: {
        status: ActionStatus.NONE,
    },
    getDataSyndicationSubscriptionAction: {
        status: ActionStatus.NONE,
    },
    getSubscriptionSourceDataSetsAction: {
        status: ActionStatus.NONE,
    },
    dataSyndicationSubscriptionListResult: {
        Items: [],
    },
    subscription: null,
    confirmDataSyndicationSubscriptionActions: {},
    dataSets: [],
};

export default function dataSyndicationSubscriptionReducer(state = initialState, action) {
    switch (action.type) {
        case GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_REQUEST:
            return {
                ...state,
                getDataSyndicationSubscriptionListAction: {
                    status: ActionStatus.PENDING,
                },
                dataSyndicationSubscriptionListResult: {
                    Items: [],
                },
                confirmDataSyndicationSubscriptionActions: {},
            };
        case GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_SUCCESS:
            return {
                ...state,
                getDataSyndicationSubscriptionListAction: {
                    status: ActionStatus.SUCCESS,
                },
                dataSyndicationSubscriptionListResult: action.payload.result,
            };
        case GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_FAILURE:
            return {
                ...state,
                getDataSyndicationSubscriptionListAction: {
                    status: ActionStatus.FAILED,
                    error: action.payload.error,
                },
                dataSyndicationSubscriptionListResult: {
                    Items: [],
                },
            };
        case GET_DATA_SYNDICATION_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                getDataSyndicationSubscriptionAction: {
                    status: ActionStatus.PENDING,
                },
                subscription: null,
            };
        case GET_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                getDataSyndicationSubscriptionAction: {
                    status: ActionStatus.SUCCESS,
                },
                subscription: action.payload.subscription,
            };
        case GET_DATA_SYNDICATION_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                getDataSyndicationSubscriptionAction: {
                    status: ActionStatus.FAILED,
                    error: action.payload.error,
                },
                subscription: null,
            };
        case CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                confirmDataSyndicationSubscriptionActions: { ...state.confirmDataSyndicationSubscriptionActions, [action.params.subscriptionId]: { status: ActionStatus.PENDING } },
            };
        case CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                confirmDataSyndicationSubscriptionActions: {
                    ...state.confirmDataSyndicationSubscriptionActions,
                    [action.payload.subscriptionId]: { status: ActionStatus.SUCCESS },
                },
            };
        case CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                confirmDataSyndicationSubscriptionActions: {
                    ...state.confirmDataSyndicationSubscriptionActions,
                    [action.payload.subscriptionId]: { status: ActionStatus.FAILED, error: action.payload.error },
                },
            };
        case GET_SUBSCRIPTION_SOURCE_DATA_SETS_REQUEST:
            return {
                ...state,
                getSubscriptionSourceDataSetsAction: {
                    status: ActionStatus.PENDING,
                },
                dataSets: [],
            };
        case GET_SUBSCRIPTION_SOURCE_DATA_SETS_SUCCESS:
            return {
                ...state,
                getSubscriptionSourceDataSetsAction: {
                    status: ActionStatus.SUCCESS,
                },
                dataSets: action.payload.dataSets,
            };
        case GET_SUBSCRIPTION_SOURCE_DATA_SETS_FAILURE:
            return {
                ...state,
                getSubscriptionSourceDataSetsAction: {
                    status: ActionStatus.FAILED,
                    error: action.payload.error,
                },
                dataSets: [],
            };
        default:
            return state;
    }
}
